import {createContext, ReactNode, useCallback, useContext, useMemo, useState} from "react";

import {PriceStat} from "../constants/price_stat";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {DEFAULT_ROOMS_FILTER} from "../constants/rooms_filter_options";

interface PricesFilterContextValue {
    rooms: RoomsFilter;
    setRooms: (rooms: RoomsFilter) => void;
    priceStat: PriceStat;
    setPriceStat: (priceStat: PriceStat) => void;
    districtRooms: RoomsFilter;
    setDistrictRooms: (rooms: RoomsFilter) => void;
}

interface Props {
    children: ReactNode;
}

const PricesFilterContext = createContext<PricesFilterContextValue | null>(null);

export const PricesContextFilterProvider = (props: Props) => {
    const {children} = props;

    const [rooms, setRoomsState] = useState<RoomsFilter>(DEFAULT_ROOMS_FILTER);
    const [priceStat, setPriceStat] = useState<PriceStat>("average");
    const [districtRooms, setDistrictRoomsState] = useState<RoomsFilter>(DEFAULT_ROOMS_FILTER);

    // The districts table keeps its own rooms filter - it always shows average data, so it stays
    // selectable even when priceStat === "median" disables the shared rooms control elsewhere.
    // A change from the shared control always cascades down to districts...
    const setRooms = useCallback((value: RoomsFilter) => {
        setRoomsState(value);
        setDistrictRoomsState(value);
    }, []);

    // ...but a change from the districts table only cascades back up while "average" is active -
    // while "median" is active the shared control is disabled/irrelevant, so districts stays local.
    const setDistrictRooms = useCallback(
        (value: RoomsFilter) => {
            setDistrictRoomsState(value);

            if (priceStat === "average") {
                setRoomsState(value);
            }
        },
        [priceStat]
    );

    const value = useMemo(
        () => ({rooms, setRooms, priceStat, setPriceStat, districtRooms, setDistrictRooms}),
        [rooms, setRooms, priceStat, districtRooms, setDistrictRooms]
    );

    return <PricesFilterContext.Provider value={value}>{children}</PricesFilterContext.Provider>;
};

export const usePricesContext = (): PricesFilterContextValue => {
    const context = useContext(PricesFilterContext);

    if (!context) {
        throw new Error("usePricesContext must be used within a PricesContextFilterProvider");
    }

    return context;
};
import {createContext, ReactNode, useCallback, useContext, useMemo, useState} from "react";

import {PriceStat} from "../constants/price_stat";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {DEFAULT_ROOMS_FILTER} from "../constants/rooms_filter_options";

interface PricesFilterContextValue {
    rooms: RoomsFilter;
    setRooms: (rooms: RoomsFilter) => void;
    priceStat: PriceStat;
    setPriceStat: (priceStat: PriceStat) => void;
    districtRooms: RoomsFilter;
    setDistrictRooms: (rooms: RoomsFilter) => void;
}

interface Props {
    children: ReactNode;
}

const PricesFilterContext = createContext<PricesFilterContextValue | null>(null);

export const PricesContextFilterProvider = (props: Props) => {
    const {children} = props;

    const [rooms, setRoomsState] = useState<RoomsFilter>(DEFAULT_ROOMS_FILTER);
    const [priceStat, setPriceStat] = useState<PriceStat>("average");
    const [districtRooms, setDistrictRoomsState] = useState<RoomsFilter>(DEFAULT_ROOMS_FILTER);

    // The districts table keeps its own rooms filter - it always shows average data, so it stays
    // selectable even when priceStat === "median" disables the shared rooms control elsewhere.
    // A change from the shared control always cascades down to districts...
    const setRooms = useCallback((value: RoomsFilter) => {
        setRoomsState(value);
        setDistrictRoomsState(value);
    }, []);

    // ...but a change from the districts table only cascades back up while "average" is active -
    // while "median" is active the shared control is disabled/irrelevant, so districts stays local.
    const setDistrictRooms = useCallback(
        (value: RoomsFilter) => {
            setDistrictRoomsState(value);

            if (priceStat === "average") {
                setRoomsState(value);
            }
        },
        [priceStat]
    );

    const value = useMemo(
        () => ({rooms, setRooms, priceStat, setPriceStat, districtRooms, setDistrictRooms}),
        [rooms, setRooms, priceStat, districtRooms, setDistrictRooms]
    );

    return <PricesFilterContext.Provider value={value}>{children}</PricesFilterContext.Provider>;
};

export const usePricesContext = (): PricesFilterContextValue => {
    const context = useContext(PricesFilterContext);

    if (!context) {
        throw new Error("usePricesContext must be used within a PricesContextFilterProvider");
    }

    return context;
};
